import Button from '@blocks/Button'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import { route } from '@helpers'
import { colors } from '@styles/vars'
import React from 'react'
import { Link } from 'react-router-dom'

export default function SupportSection() {
    return (
        <Grid gap="10px">
            <Grid gap="0px">
                <small><Link to={route("general:support")} style={{ textDecoration: "none", color: colors.darkGrey }}>Support</Link></small>
                <hr />
            </Grid>
            <Grid columns="3">
                <EmphasizedContent background="white">
                    <Grid gap="15px">
                        <Grid gap="5px">
                            <h4>If you have any problems with a website or salons, please, contact the support</h4>
                            <p>We care about your comfort. Report an issue and we'll fix it as soon as possible.</p>
                        </Grid>
                        <Button type="tertiary" to={route("general:support")} element="a" target="_blank">Report</Button>
                    </Grid>
                </EmphasizedContent>
            </Grid>
        </Grid>
    )
}